import QRCode from 'qrcode';

$(document).on('click', '#amSpotShowMissionQR', async () => {
  $('#amMissionQR').removeAttr('src');

  const spot = window.Gdata.CurrentSpots.dic[window.SpotEditId || ''];
  if (!spot || !spot.map_id) {
    return;
  }

  const mapData = window.Gdata.CurrentMap.ori[0];
  let milestone = typeof mapData.milestone !== 'undefined' ? mapData.milestone : '';
  let encodeTitle = encodeURIComponent(mapData.title);
  const encodedString = encodeURIComponent(btoa(`${spot.map_id},${spot._id},${milestone},${encodeTitle}`));
  // const encodedString = encodeURIComponent(btoa(`${spot.map_id},${spot._id},${milestone},${mapData.title}`));

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  const qrWidth = 300;
  const qrHeight = 300;

  const padding = 50;
  const totalWidth = qrWidth + padding * 2;
  const totalHeight = qrHeight + padding * 2;

  canvas.width = totalWidth;
  canvas.height = totalHeight;

  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, totalWidth, totalHeight);

  const base64 = await QRCode.toDataURL(`${window.AS.ALIAS_MAP_MISSION_QR_URL}/?t=${encodedString}`, {
    margin: 0,
    width: qrWidth,
    color: {
      dark: '#000000',
      light: '#ffffff',
    },
  });

  const qrImage = new Image();
  qrImage.src = base64;
  qrImage.onload = () => {
    ctx.drawImage(qrImage, padding, padding, qrWidth, qrHeight);
    $('#amMissionQR').attr('src', canvas.toDataURL());
  };
});

$(document).on('click', '#amMissionDownloadQR', () => {
  const spot = window.Gdata.CurrentSpots.dic[window.SpotEditId || ''];
  if (!spot || !spot.map_id) {
    return;
  }

  const downloadLink = document.createElement('a');
  downloadLink.href = String($('#amMissionQR').attr('src'));
  downloadLink.download = `ミッションQRコード（${spot.title}）.png`;
  downloadLink.click();
});
